<template>
    <div class="row">
        <div class="col-12" v-if="settings.type === 'profile_information'">
            <div v-if="loading">
                <spinner-component/>
            </div>
            <div v-else>
                <label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Company Profile Information</label>
                <ul class="list-unstyled lh-7">
                    <li class="d-flex justify-content-between">
                        <span>Company Name: </span>
                        <span class="tx-semibold">{{ settings.data.name|placeholder }}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>Registration Number: </span>
                        <span class="tx-semibold">{{ settings.data.registration_number|placeholder }}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>Email Address: </span>
                        <span class="tx-semibold">{{ settings.data.email|placeholder }}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>Phone Number: </span>
                        <span class="tx-semibold">{{ settings.data.phone|placeholder }}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>Address: </span>
                        <span class="tx-semibold"></span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>Country: </span>
                        <span class="tx-semibold">{{ country.name }}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>City/Town: </span>
                        <span class="tx-semibold">{{ country.city.name }}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>In Which Country Are You Resident For Tax Purposes? </span>
                        <span class="tx-semibold">{{ settings.data.country_for_tax|placeholder }}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>Industry: </span>
                        <span class="tx-semibold">{{ industry.name|placeholder }}</span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="col-12" v-if="settings.type === 'executive_information'">
            <label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Executive Information</label>
            <ul class="list-unstyled lh-7">
                <li class="d-flex justify-content-between">
                    <span>CEO: </span>
                    <span class="tx-semibold">{{ settings.data.ceo|placeholder }}</span>
                </li>
                <li class="d-flex justify-content-between">
                    <span>Secretary: </span>
                    <span class="tx-semibold">{{ settings.data.secretary|placeholder }}</span>
                </li>
                <li class="d-flex justify-content-between">
                    <span>Board Of Directors: </span>
                    <span class="tx-semibold">{{ settings.data.board_of_directors.join(', ')|placeholder }}</span>
                </li>
            </ul>
        </div>

        <div class="col-12" v-if="settings.type === 'financial_information'">
            <label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Withdrawal Information</label>
            <ul class="list-unstyled lh-7">
                <li class="d-flex justify-content-between">
                    <span>Average Investment Amount: </span>
                    <span class="tx-semibold">{{ settings.data.average_investment_amount|toCurrency(settings.data.currency) }}</span>
                </li>
            </ul>
        </div>

        <div class="col-12" v-if="settings.type === 'bank_account_information'">
            <div v-if="loading">
                <spinner-component/>
            </div>
            <div v-else>
                <label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Bank Account Information for GHS</label>
                <ul class="list-unstyled lh-7">
                    <li class="d-flex justify-content-between">
                        <span>Bank Name: </span>
                        <span class="tx-semibold">{{ bankAccounts.ghs.bank|placeholder }}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>Branch Name: </span>
                        <span class="tx-semibold">{{ bankAccounts.ghs.branch|placeholder }}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>Account Number: </span>
                        <span class="tx-semibold">{{ settings.data.ghs_account_number|placeholder }}</span>
                    </li>
                </ul>

                <label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Bank Account Information for USD</label>
                <ul class="list-unstyled lh-7">
                    <li class="d-flex justify-content-between">
                        <span>Bank Name: </span>
                        <span class="tx-semibold">{{ bankAccounts.usd.bank|placeholder }}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>Branch Name: </span>
                        <span class="tx-semibold">{{ bankAccounts.usd.branch|placeholder }}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>Account Number: </span>
                        <span class="tx-semibold">{{ settings.data.usd_account_number|placeholder }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				error: null,
				bankAccounts: {
					ghs: null,
					usd: null
				},
				country: null,
				industry: null
			};
		},
		created() {
			this.initialize();
		},
		watch: {
			"settings.type": function() {
				this.initialize();
			}
		},
		methods: {
			initialize() {
				if (this.settings.type === "bank_account_information") {
					this.fetchBanks();
				}

				if (this.settings.type === "profile_information") {
					this.fetchProfileOptions();
				}
			},
			fetchGhsBank() {
				return axios.get(`/api/banks/${this.settings.data.ghs_bank}`);
			},
			fetchUsdBank() {
				return axios.get(`/api/banks/${this.settings.data.usd_bank}`);
			},
			fetchBanks() {
				this.error = null;
				this.loading = true;

				axios
					.all([this.fetchGhsBank(), this.fetchUsdBank()])
					.then(
						axios.spread((ghs, usd) => {
							if (!_.isEmpty(ghs.data.data.bank)) {
								const branch = this.filterBranches(
									ghs.data.data.bank.branches,
									this.settings.data.ghs_branch
								);

								this.bankAccounts.ghs = {
									bank: ghs.data.data.bank.name,
									branch: branch.name
								};
							}

							if (!_.isEmpty(usd.data.data.bank)) {
								const branch = this.filterBranches(
									usd.data.data.bank.branches,
									this.settings.data.usd_branch
								);

								this.bankAccounts.usd = {
									bank: usd.data.data.bank.name,
									branch: branch.name
								};
							}
						})
					)
					.catch(error => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = false;
					});
			},
			fetchCountry() {
				return axios.get(
					`/api/options/countries/${this.settings.data.country}`
				);
			},
			fetchIndustry() {
				return axios.get(
					`/api/options/industries/${this.settings.data.industry}`
				);
			},
			fetchProfileOptions() {
				this.error = null;
				this.loading = true;

				axios
					.all([this.fetchCountry(), this.fetchIndustry()])
					.then(
						axios.spread((country, industry) => {
							if (!_.isEmpty(country.data.data.country)) {
								const city = _.find(
									country.data.data.country.cities,
									city => {
										return (
											city.id.toString() ===
											this.settings.data.city
										);
									}
								);

								delete country.data.data.country.cities;

								this.country = {
									...country.data.data.country,
									city
								};
							}

							if (!_.isEmpty(industry.data.data.profession_option)) {
								this.industry =
									industry.data.data.profession_option;
							}
						})
					)
					.catch(error => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = false;
					});
			},
			filterBranches(bank, branch) {
				return _.find(bank, o => {
					return o.routing_number === branch;
				});
			}
		},
		props: ["settings"]
	};
</script>